<template>
  <CustomizationFunnel
    :breadcrumb
    :is-services-pickers-response-pending
    :pickers="pickersResponse"
    :pickers-services="pickersServices?.pickerGroups ?? []"
    :price
    :price-without-subsidies
    :price-without-trade-in
    :product
    :product-tracking
    :selected-mobile-plan
    :selected-offer
    :technical-specifications
  >
    <template #sticky-bar="{ title }">
      <ClientOnly>
        <StickyBarTop
          :price
          :product
          :review-count
          :selected-mobile-plan
          :selected-offer
          :title
          :tracking="productTracking"
          @hide="handleHideTopBar"
          @show="handleShowTopBar"
        />

        <StickyBarTopSmall
          :review-count
          :select="selectedOffer.shipping"
          :shipping="selectedOffer.shipping"
          :title
          @hide="handleHideTopBar"
          @show="handleShowTopBar"
        />
      </ClientOnly>
    </template>
  </CustomizationFunnel>
</template>

<script lang="ts" setup>
import type { Price } from '@backmarket/http-api'
import type { MobilePlanOffer } from '@backmarket/http-api/src/api-specs-b2c-services/mobile-plan/types/mobile-plan-offers'
import type { GetBreadcrumbResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/breadcrumb'
import type {
  GetPickersResponse,
  GetServicesPickersResponse,
} from '@backmarket/http-api/src/api-specs-navigation-experience/product/pickers'
import type { GetProductResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/product'
import type { GetTechnicalSpecificationsResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/technical-specifications'

import { useProductTracking } from '~/scopes/product-core/composables/useProductTracking/useProductTracking'

import CustomizationFunnel from '../CustomizationFunnel/CustomizationFunnel.vue'
import StickyBarTop from '../StickyBarTop/StickyBarTop.vue'
import StickyBarTopSmall from '../StickyBarTopSmall/StickyBarTopSmall.vue'

defineProps<{
  breadcrumb?: GetBreadcrumbResponse | null | undefined
  selectedOffer: NonNullable<GetPickersResponse['selectedOffer']>
  pickersResponse: GetPickersResponse
  pickersServices: GetServicesPickersResponse | null
  isServicesPickersResponsePending: boolean
  price: Price
  priceWithoutSubsidies?: Price | null
  priceWithoutTradeIn?: Price | null
  product: GetProductResponse
  selectedMobilePlan?: MobilePlanOffer
  productTracking: ReturnType<typeof useProductTracking>
  technicalSpecifications: GetTechnicalSpecificationsResponse | undefined
  reviewCount: number
}>()

const emit = defineEmits(['hide', 'show'])

function handleShowTopBar() {
  emit('show')
}
function handleHideTopBar() {
  emit('hide')
}
</script>
